import createStore from './store'

const { store, persistor } = createStore()

export { store, persistor }